import Reveal from "./Reveal";
import { MANIFESTO } from "../content";

export default function Manifesto() {
  const cardColors = ["bg-pastel-pink/70", "bg-pastel-blue/70", "bg-pastel-mint/70"];
  return (
    <section id="manifesto" className="py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-16">
        <Reveal>
          <h2 className="max-w-3xl font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-ink md:text-6xl">
            Get your time back.
            <br />
            Do what you love.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
          {MANIFESTO.map((chapter, i) => (
            <Reveal key={chapter.num} delay={i * 0.08} className="h-full">
              <div
                data-testid={`manifesto-chapter-${chapter.num}`}
                className={`h-full rounded-2xl border-2 border-ink p-7 shadow-chunk transition-transform duration-300 hover:rotate-0 ${
                  cardColors[i % cardColors.length]
                } ${i % 2 === 1 ? "md:rotate-1" : "md:-rotate-1"}`}
              >
                <span className="font-display text-sm font-extrabold tracking-[0.2em] text-ink/60">
                  {chapter.num}
                </span>
                <h3 className="mt-4 font-display text-2xl font-extrabold leading-tight tracking-tight text-ink">
                  {chapter.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink/70">
                  {chapter.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        {MANIFESTO.filter((c) => c.image).map((chapter, i) => (
          <Reveal key={chapter.num} className="py-10 first:pt-14 md:py-14">
            <img
              src={chapter.image}
              alt={chapter.caption}
              loading="lazy"
              className={`aspect-[16/9] w-full rounded-3xl border-2 border-ink object-cover shadow-chunk-lg md:aspect-[21/9] ${
                i % 2 === 1 ? "rotate-[0.75deg]" : "-rotate-[0.75deg]"
              }`}
              data-testid={`manifesto-image-${chapter.num}`}
            />
          </Reveal>
        ))}
      </div>
    </section>
  );
}
